<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '备用金申请' ,path:'/item'}"></Title>


    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">备用金信息</el-divider>
        <el-form-item label="申请人" prop="userId">
          <el-select
              v-model="ruleForm.userId"
              placeholder="请选择申请人"
              style="width: 100%"
          >
            <el-option
                v-for="item in allSysUser"
                :key="item.userId"
                :label="item.realName"
                :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请类型" prop="type" required>
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="1">项目费用</el-radio>
            <el-radio label="2">管理费用</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="ruleForm.type === '1'">
          <el-form-item label="申请项目" prop="projectId">
            <el-select
                style="width: 50%"
                v-model="ruleForm.projectId"
                placeholder="请选择申请项目"
                filterable
                @change="handleProjectChange(ruleForm.projectId)"
            >
              <el-option
                  v-for="item in projectList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :disabled="item.projectState === 6"
                  :value="item.projectId"
              >
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="申请金额" prop="amount">
          <el-input v-model="ruleForm.amount" maxlength="12">
            <template slot="append">{{ paymentUpperMap.applyMoney }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="申请用途" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark" rows="5" maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>

        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>
      </el-form>
    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "@/util";
import {
  requestAllProject,
  requestApplyDetail, requestPettyCashApply, requestUserGet
} from "@/api";

export default {
  components: {Title},
  name: "CostReportApply",
  data() {
    const validatePrice = (rule, value, callback) => {

      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        callback();
      }
    };
    return {
      projectList: [],
      submitShow: true,
      dialogVisible: false,
      userList: [],
      applyServiceId: "",
      applyType: "",
      pettyCashId: null,
      applyId: null,
      reapply: false,

      ruleForm: {
        userId: "",
        type: "1",
        projectId: "",
        amount: "",
        remark: "",
      },
      rules: {
        userId :[
          {required: true, message: '请选择申请人', trigger: 'blur'},
        ],
        projectId :[
          {required: true, message: '请选择申请项目', trigger: 'blur'},
        ],
        amount: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        remark: [
          {required: true, message: '请输入申请用途', trigger: 'blur'},
          {max: 200, message: '长度最大200个字符', trigger: 'blur'}
        ],
      },
      allSysUser: [],
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        applyMoney: digitUppercase(this.ruleForm.amount),
      }
    }
  },
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.loadSysUserData()
    this.getAllProject()
  },
  methods: {
    digitUppercase,
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 重新申请需要的参数
          if (this.reapply) {
            this.ruleForm.pettyCashId = this.pettyCashId
            this.ruleForm.applyId = this.applyId
            this.ruleForm.reapply = this.reapply
          }

          this.submitShow = false
          requestPettyCashApply(this.ruleForm).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('ruleForm')
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查询申请详情
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            let detail = res.object.detail
            this.paymentId = detail.paymentId
            for (let key in this.ruleForm) {
              if (detail[key] != null) {
                this.ruleForm[key] = detail[key].toString()
              } else {
                this.ruleForm[key] = detail[key]
              }
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code === 200) {
        this.allSysUser = res.object;
      } else {
        this.$message.error("获取人员列表失败");
      }
    },
    // 选择项目
    handleProjectChange(projectId){
      this.getAllContractByProjectId(projectId)
    },
    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>




